import React, { Component } from 'react'
import { compose } from 'react-apollo'
import withEmployees from 'containers/withEmployees'
import { Container, Row, Col } from 'styled-bootstrap-grid'

import Employee from './Employee'

class Employees extends Component {
  state = { finishedSorting: false }

  getEmployees() {
    const sortedList = this.props.employees.sort((a, b) => {
      return a.menuOrder - b.menuOrder
    })

    return sortedList
  }
  render() {
    const {
      employeesLoading,
      showAll,
      employeeList
    } = this.props

    if (employeesLoading) return null

    const employees = this.getEmployees()

    return(
      <Container fluid>
        <Row>
          {showAll ?
            employees.map(employee => {
              return(
                <Col
                  md={6}
                  lg={4}
                  xl={3}
                  key={employee.id}
                >
                  <Employee
                    name={employee.title}
                    position={employee.position}
                    image={employee.image ? employee.image.sourceUrl : null}
                    email={employee.email}
                    text={employee.text}
                  />
                </Col>
              )
            })
          :
            employeeList.map(employee => {
              return(
                <Col
                  md={6}
                  lg={4}
                  xl={3}
                  key={employee.id}
                >
                  <Employee
                    name={employee.title}
                    position={employee.position}
                    image={employee.image ? employee.image.sourceUrl : null}
                    email={employee.email}
                    text={employee.text}
                  />
                </Col>
              )
            })
          }
        </Row>
      </Container>
    )
  }
}

export default compose(
  withEmployees(),
)(Employees)



// WEBPACK FOOTER //
// ./src/ui/components/modules/Employees/index.js